<div class="card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="segments"
      [totalRecords]="segments.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
  </div>
</div>

<ng-template #contactsTpl let-row>
  <button
    type="button"
    class="btn btn-link btn-sm segment-list__contacts-trigger"
    [attr.aria-label]="'Settings::CRM:Definitions:ShowAssignedContacts' | abpLocalization"
    [attr.aria-expanded]="contactsPopoverOpen && contactsPopoverSegmentId === row.id"
    (click)="onContactsClick(row, $event)">
    {{ row.contactCount ?? 0 }}
  </button>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>

<app-crm-segment-manage-contacts-dialog
  [visible]="showManageContactsDialog"
  [segment]="selectedSegmentForManage"
  (visibleChange)="showManageContactsDialog = $event"
  (saved)="onManageContactsSaved()" />

<p-popover
  #contactsPopover
  [dismissable]="true"
  [focusOnShow]="false"
  styleClass="segment-list__contacts-popover"
  (onShow)="onContactsPopoverShow()"
  (onHide)="onContactsPopoverHide()">
  <app-crm-segment-assigned-contacts
    [contacts]="popoverContacts"
    [loading]="popoverLoading"
    [loadingMore]="popoverLoadingMore"
    [totalCount]="popoverTotalCount"
    [title]="'Settings::CRM:Definitions:AssignedContactsTitle' | abpLocalization"
    [emptyMessage]="'Settings::CRM:Definitions:NoContactsAssigned' | abpLocalization"
    (loadMore)="onContactsLoadMore()" />
</p-popover>
